module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAOCAYAAADNGCeJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADMSURBVHgBrZPhEYIwDIVTj//iBnUDRtANHKErOAE4CW6iG8gGsAFsUF8w5SIePa28u3flSvI1CdR47y0RlTCvKRrgizGmMYC1f4A0cE/+pQclCrm1MGyAsVrY/QA5wDeVP8F6sZcAG4HkqppQxBtsBMBXFVRrqEDK2aEFXH3AVFKhThtbl5b03knFL8NUkFOAMApOzGdxEyxbmg3+G275jscK3sJn7HUUURZ7KcmOvtSGVtSqML5OPVYeakdpysU7ruwIN5Quvpf8cYYnjm4e89RpK9sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/jump/icon-email.png
// module id = rpZf
// module chunks = 0